import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bowserFlags } from 'lib/bowser'
import appendQuery from 'append-query'
import { setCookies } from 'lib/cookies'

import { Modal, ModalBody } from 'components/modal'
import { TwoColumnResponsiveLayout } from 'components/presentation'

import { NEW_RESERVATION_ID } from 'cart/constants'
import { UPDATE_CART_SUMMARY } from 'shared/constants'
import { reservationPath } from 'lib/urls'
import { track, tracking } from 'lib/analytics'
import { RESERVE_ACTION_CHECKOUT, RESERVE_ACTION_PURCHASED } from '../constants'

import { handleOfferClick as onOfferClick, offersWithLinks } from '../lib'
import { createReservation } from '../actions'

import Offer from '../../shared/offer'
import AddToCartForm from '../components/add-to-cart-form'
import RegItem from '../components/reg-item'

@tracking(({ regItem }) => ({ regItem }))
export class GiveThisGiftModal extends PureComponent {
  // using manual tracking as oppose to decorator because we're having
  // a fakely delay promise completion in case of redirect to checkout
  handleSubmit = ({
    email,
    giftAmount,
    name,
    productId,
    quantity,
    submitBtnClicked,
    subscribeToMarketingEmail,
  }) => {
    const {
      onHide,
      onSubmit,
      openPurchaseInfoModal,
      registry,
      regItem,
      tracking: tracker,
    } = this.props
    const reservation = {
      id: NEW_RESERVATION_ID,
      regItemId: regItem.id,
      regItem,
      registryId: registry ? registry.id : regItem.registryId,
      email,
      name,
      productId,
      quantity: quantity || 1,
      isPurchased: submitBtnClicked == RESERVE_ACTION_PURCHASED,
      giftAmount,
      subscribeToMarketingEmail,
    }

    const trackAddToCart = (subscribeToMarketingEmail) => {
      // addToCart tracking
      tracker.trackEvent({
        // regItem already set at component level
        cartItemQuantity: quantity ? parseInt(quantity) : 1,
        productPrice:
          (giftAmount && parseFloat(giftAmount)) || parseFloat(regItem.price),
        productType: giftAmount
          ? track.ProductType.GIFT_CARD
          : track.ProductType.PRODUCT,
        eventCta: submitBtnClicked,
        event: track.addedToCart,
        eventType: track.EventType.ADDED_TO_STORE_RESERVATION,
        subscribeToMarketingEmail: subscribeToMarketingEmail === 'true',
      })
    }
    return onSubmit(reservation).then((newReservation) => {
      setCookies({ name, email, subscribeToMarketingEmail })
      if (
        [RESERVE_ACTION_CHECKOUT, RESERVE_ACTION_PURCHASED].includes(
          submitBtnClicked
        )
      ) {
        const newReservationPath = reservationPath(newReservation.token)
        if (submitBtnClicked == RESERVE_ACTION_PURCHASED) {
          onHide()
          openPurchaseInfoModal(regItem, newReservation)
          // reservationUpdated (mark as purchased) tracking
          // DO NOT fire added to store reservation
          tracker.trackEvent({
            // regItem already set at component level
            event: track.reservationUpdated,
            eventType: track.EventType.MARK_AS_PURCHASED,
            subscribeToMarketingEmail,
          })
        } else {
          trackAddToCart(subscribeToMarketingEmail)
        }
        if (submitBtnClicked == RESERVE_ACTION_CHECKOUT) {
          window.location.href = newReservationPath
        }
        // deferring promise resolution an arbitrary amount of time so that the
        // submit buttons remain disabled in "submitting" state while the
        // browser is loading the next page
        return new Promise((resolve) => setTimeout(resolve, 10000))
      }
      // Reserve and Keep Shopping
      trackAddToCart(subscribeToMarketingEmail)
      onHide()
      PubSub.publish(UPDATE_CART_SUMMARY, {
        showCartDropdown: true,
        animateBadge: true,
      })
    })
  }

  renderBuyingOptions = (regItem) => {
    if (
      !offersWithLinks(regItem.offers).length ||
      regItem.isGiftCard ||
      regItem.isFavor
    ) {
      return null
    }

    return (
      <div>
        <div className="mbs mtn">Buying Options:</div>
        {offersWithLinks(regItem.offers).map((offer, index) => {
          // Add the reg item ID as a param to the URL if it's a BabyList offer, so that we can auto-create a
          // reservation if the user bypasses the normal add to cart flow and just makes a purchase directly
          // from the link
          const offerUrl =
            offer.storeName == 'Babylist'
              ? appendQuery(offer.affiliateUrl, { reg_item_id: regItem.id })
              : offer.affiliateUrl

          return (
            <Offer
              /* eslint-disable-next-line no-script-url */
              href="javascript:void(0)"
              storeIconName={offer.storeIconName}
              isLink
              key={offer.storeIconName}
              onClick={(e) =>
                onOfferClick(offer.storeName, offerUrl, offer.viglinkEnabled)
              }
              price={offer.price}
              storeName={offer.storeName}
            />
          )
        })}
      </div>
    )
  }

  render() {
    const { onHide, registry, regItem } = this.props
    const modalTitle = regItem.isGroupGift
      ? 'Purchase This Gift'
      : `Reserve Gift${registry ? ` for ${registry.firstNames}` : ''}`

    return (
      <Modal show onHide={onHide} size="large" title={modalTitle}>
        <ModalBody>
          <TwoColumnResponsiveLayout key="AddToCart">
            <div>
              <RegItem className="mbl" registry={registry} regItem={regItem} />
              {!bowserFlags.mobile ? this.renderBuyingOptions(regItem) : null}
            </div>
            <div>
              {/* onFormSubmit -- need a different name for this func so that reduxForm doesn't autobind it. */}
              <AddToCartForm
                className={bowserFlags.mobile ? 'mbl' : null}
                onFormSubmit={this.handleSubmit}
                regItem={regItem}
              />
              {bowserFlags.mobile ? this.renderBuyingOptions(regItem) : null}
            </div>
          </TwoColumnResponsiveLayout>
        </ModalBody>
      </Modal>
    )
  }
}

GiveThisGiftModal.propTypes = {
  registry: PropTypes.object,
  regItem: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  openPurchaseInfoModal: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  tracking: PropTypes.func.isRequired,
}

GiveThisGiftModal.defaultProps = {
  registry: undefined,
}

// ⚠️this component is also used wrapped in a modal which use the component directly and not the default export -> reservation-modal.jsx
// so if updating this connect, update the other one..
// of fix this ^^
export default connect(null, { onSubmit: createReservation })(GiveThisGiftModal)
